export default __webpack_public_path__ + "static/media/HomeLoanInsurance.8ee87a32.svg";